enum SoftwareVersion {
  Master = 'master',
  Staging = 'staging',
  Beta = 'beta',
  Develop = 'develop',
  Custom = 'custom',
}

export default SoftwareVersion;
